module.exports = __webpack_public_path__ + "static/img/btn_close.1d7aca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_close.png
// module id = Dbwr
// module chunks = 156